/*
 * Shared price helpers for the booking forms.
 *
 * Prices are typed by editors in the back-office, so they may arrive as
 * "700", "700 €" or "700,50" depending on how the field was filled in.
 */

export const parsePrice = (value) => {
  const parsed = parseFloat(
    String(value === undefined || value === null ? "" : value)
      .replace(",", ".")
      .replace(/[^0-9.-]/g, "")
  );
  return isNaN(parsed) ? 0 : parsed;
};

// Keeps whole amounts clean while still supporting cents
export const formatPrice = (value) =>
  Number.isInteger(value) ? String(value) : value.toFixed(2);
